import { z } from "zod";

export const orgSlugSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/, "kleine letters, cijfers en '-'");

export const domainSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/, "ongeldig domein");

export const emailSchema = z.string().trim().toLowerCase().pipe(z.email("Ongeldig e-mailadres"));

/** Domeindeel van een e-mailadres, in kleine letters. */
export const emailDomain = (email: string): string => email.slice(email.lastIndexOf("@") + 1).toLowerCase();
